import React from "react";
import ReactDOM from "react-dom";
import "./scss/index.scss";
import App from "./App";
import { ProfileUserProvider } from "./lib/profileContext";

ReactDOM.render(
  <React.StrictMode>
    <ProfileUserProvider>
      <App />
    </ProfileUserProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
